import { render, staticRenderFns } from "./renovacao.vue?vue&type=template&id=1b877f17&scoped=true"
import script from "./renovacao.vue?vue&type=script&lang=js"
export * from "./renovacao.vue?vue&type=script&lang=js"
import style0 from "./renovacao.vue?vue&type=style&index=0&id=1b877f17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b877f17",
  null
  
)

export default component.exports